import * as React from "react";

import { Step } from "../../TourTypes";

import { PrintErrorLogImageContainer } from "./PrintErrorLog.styles";

export const printErrorLog: Step = {
    id: "candyform_printerrorlog",
    header: "Скачайте результат проверки",
    content: (
        <div>
            {"Список всех ошибок можно скачать, чтобы напечатать или отправить по эл.почте."}
            <br />
            <PrintErrorLogImageContainer />
        </div>
    ),
    positions: ["right top"],
    group: ["panel"],
    order: 40,
    offset: -20,
};
